import { useEffect, useState } from 'react';

export const useTranslationMonitor = () => {
  const [isTranslating, setIsTranslating] = useState(false);

  useEffect(() => {
    const checkTranslation = () => {
      const iframe = document.querySelector('.goog-te-menu-frame');
      if (iframe) {
        setIsTranslating(true);
        
        const observer = new MutationObserver((mutations) => {
          const translatedElements = document.querySelectorAll('[data-original-text]');
          if (translatedElements.length > 0) {
            setIsTranslating(false);
            observer.disconnect();
          }
        });

        observer.observe(document.body, {
          childList: true,
          subtree: true,
          attributes: true,
          characterData: true
        });

        const timeout = setTimeout(() => {
          setIsTranslating(false);
          observer.disconnect();
        }, 5000);

        return () => {
          clearTimeout(timeout);
          observer.disconnect();
        };
      }
    };

    const interval = setInterval(checkTranslation, 100);
    return () => clearInterval(interval);
  }, []);

  return isTranslating;
};